import React, {useEffect, useState} from "react";
import {
    Backdrop,
    Divider,
    Fade,
    Modal,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {Rating} from "@material-ui/lab";
import BasicInput from "../../custom/BasicInput";
import {
    updateCallReview,
} from "../../../api/globalDialerApi";
import Utils from "../../../helpers/Utils";
import CallDispositionSkeleton from "./CallDispositionSkeleton";

const useStyles = makeStyles((theme) => ({
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        padding: '10px 16px 16px 16px',
        borderRadius: 8,
        maxWidth: 730,
        width: "100%",
        color: '#222241',
    },
    header: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingBottom: 8,
        marginBottom: 20,
        gap: "5px",
        borderBottom: "1px solid #ccc",
    },
    headerTxt: {
        display: "flex",
        padding: "5px 6px",
        flexDirection: "column",
    },
    logo: {
        width: 50,
        height: 50,
        objectFit: "cover",
    },
    title: {
        fontSize: "20px",
        fontWeight: 600,
    },
    contactBubble: {
        color: "#fff",
        padding: "4px 12px",
        overflow: "hidden",
        maxWidth: "160px",
        textAlign: "center",
        whiteSpace: "nowrap",
        borderRadius: "20px",
        textOverflow: "ellipsis",
        backgroundColor: "#3e50f7 !important",
        fontWeight: 600,
        fontSize: '14px',
    },
    button: {
        padding: "8px 30px",
        border: "none",
        borderRadius: "4px",
        cursor: "pointer",
    },
    confirmButton: {
        backgroundColor: "#3e50f7 !important",
        color: "#fff",
        fontSize: "16px",
        border: "2px solid #3e50f7",
        width: '100%',

        "&:focus, &:hover": {
            border: "2px solid #3e50f7",
            backgroundColor: "#3e50f7",
            transform: "translateY(-1px)",
        },
        '&:disabled': {
           opacity: 0.8,
           cursor: 'not-allowed'
        },
    },
    footer: {
        marginTop: theme.spacing(2),
        display: "flex",
        justifyContent: "flex-end",
        gap: theme.spacing(2),
        padding: '0px 20px',
    },
    topSection: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        padding: '0px 20px',

        '& .MuiTypography-root': {
            fontSize: '14px',
            color: '#000',
        },
    },
    callDisposition: {
        display: 'flex',
        alignItems: 'start',
        flex: 1,
    },
    callQualityLabel: {
        fontWeight: 600,
        marginTop: '6px',
        fontSize: '14px',
    },
    callOutcomeList: {
        paddingLeft: '25px',
        height: '150px',
        overflow: 'auto',
    },
    callRating: {
        flex: 1,
        display: 'flex',
        height: 'fit-content',
        marginLeft: '20px',
    },
    callRatingWrapper: {
        border: '1px solid #ddd',
        borderRadius: 15,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: 'fit-content',
        padding: '20px 40px 30px 40px',

        '& .MuiRating-label': {
            fontSize: '30px',
            color: '#ffb400',
        },

        '& .MuiRating-iconFilled .MuiSvgIcon-root.MuiSvgIcon-fontSizeInherit': {
            color: '#ffb400 !important',
        },

        '& .MuiRating-iconEmpty .MuiSvgIcon-root.MuiSvgIcon-fontSizeInherit': {
            color: '#00000042 !important',
        }
    },
    callRatingLabel: {
        marginBottom: '10px',
        fontSize: '13px',
        fontWeight: 600,
    },
    middleSection: {
        padding: "0px 20px",
        margin: "30px 0px",

        '& .lineML': {
            fontWeight: 600,
            marginBottom: '6px',
            fontSize: '14px',
        },
        '& .lineML1': {
            fontSize: '13px',
            color: 'rgb(105 113 133)'
        },
        '& .lineML2': {
            fontSize: '13px',
            color: 'rgb(105 113 133)'
        }
    },
    bottomSection: {
        padding: '0px 20px',
        marginTop: '8px',

        '& .MuiInputBase-root': {
          paddingTop: '10px !important',
        },

        '& .MuiInputBase-input': {
            height: 'unset !important',
        },

        '& .MuiTypography-root': {
            fontSize: '14px',
            color: '#222241',
        },
    },
    bottomSectionLabel: {
        display: 'flex',
        alignItems: 'center',
        '& span': {
            marginRight: '10px',
            fontWeight: 600,
            fontSize: '14px',
        },

        '& .MuiDivider-root': {
            flex: '1',
            backgroundColor: '#ddd',
            height: '1px',
        },
    },
    callReviewNote: {
        width: '100%',
    },
    callSummary: {
        marginTop: '10px',
        fontSize: '13px',
        color: 'rgb(105 113 133)',

        '& .callTime': {
            '& .lbl': {
                color: '#222241',
                fontWeight: 600,
            }
        },
        '& .callDetails': {
            '& .lbl': {
                color: '#222241',
                fontWeight: 600,
            }
        },
    },
}));

const capitalizeFirstLetter = (str) => {
    try{
        if (typeof str !== 'string' || str.length === 0) {
            return str;
        }
        return str.charAt(0).toUpperCase() + str.slice(1);
    }catch (err){
        return str;
    }
}

const imgSrc = `${process.env.REACT_APP_CDN_LINK}assets/images/releases/1.0.0/info-center_5650040.png`;

const generateName = (contact) => {
    let fullName = Utils.formatNumber(contact.number);

    if (contact.first_name){
        fullName = contact.first_name;
    }

    if (contact.last_name){
        if (fullName){
            fullName += ' ';
        }

        fullName += contact.last_name;
    }

    if (!fullName && contact.caller){
        fullName = Utils.formatNumber(contact.caller);
    }

    return fullName;
};

const CallReviewModal = ({ data: { contact, callReview, timeOfCall, callInfo }, open, onClose }) => {
    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [formData, setFormData] = useState({
        callReviewId: "",
        numberOfStar: "",
        note: "",
    });

    useEffect(() => {
        if (callReview?.callReviewId){
            handleChangeFormData(callReview?.callReviewId, 'callReviewId');
            handleChangeFormData(callReview?.numberOfStar, 'numberOfStar');
        }else {
            window.showNotification('error', 'No contact found');
            onClose();
        }
    }, [callReview]);

    const handleChangeFormData = (value, name) => {
        setFormData((prevState)=>({ ...prevState, [name]: value }));
    };

    const handleSubmitDisposition = async () => {
        try{
            setSubmitting(true);
            const resp = await updateCallReview(formData);

            if (resp.success){
                onClose();
                window.showNotification('success', 'Thank you for your valuable opinion');
            }else {
                window.showNotification('error', resp.message ?? 'We are facing some inconvenience at this time. Please try again later');
            }
        }catch (err){
            console.log(err);
            window.showNotification('error', 'We are facing some inconvenience at this time. Please try again later');
        }finally {
            setSubmitting(false);
        }
    };

    const renderCallTime = () => {
        if (!timeOfCall){
            return '';
        }

        try{
            let str = window.formatDateWithoutTimezoneChangeMod(timeOfCall.time, timeOfCall.timezone, "MM/DD/YYYY [at] hh:mm:ss A z");
            str = str.replace("EDT", "EST");
            return str;
        }catch (err){
            return `${timeOfCall.time} ${timeOfCall.timezone}`;
        }
    };

    const renderCallDetails = () => {
        if (!callInfo){
            return '';
        }

        let caller = '';
        let callee = '';

        if (callInfo.inOut === 'incoming'){
            caller = callInfo.number;
            callee = callInfo.toNumber;
        }else if (callInfo.inOut === 'outgoing'){
            caller = callInfo.fromNumber;
            callee = callInfo.number;
        }

        try {
            return `${capitalizeFirstLetter(callInfo.inOut)} call from ${Utils.formatNumber(caller)} to ${Utils.formatNumber(callee)}.`;
        }catch (err){
            return '';
        }
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            className={classes.modal}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{ timeout: 500 }}
        >
            <Fade in={open}>
                {
                    loading ?
                        <CallDispositionSkeleton/> :
                        <div className={classes.paper}>
                            <div className={classes.header}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    {imgSrc && (
                                        <div className={classes.logoContainer}>
                                            <img src={imgSrc} alt='logo' className={classes.logo} />
                                        </div>
                                    )}

                                    <div className={classes.headerTxt}>
                                        <div className={classes.title}>Call Quality</div>
                                    </div>
                                </div>

                                <div className={classes.contactBubble}>
                            <span>
                                {generateName(contact)}
                            </span>
                                </div>
                            </div>

                            <div>
                                <div className={classes.topSection}>
                                    <div className={classes.callDisposition}>
                                        <div className={classes.callQualityLabel}>
                                            <span>Call Quality:</span>
                                        </div>

                                        <div className={classes.callRating}>
                                            <div className={classes.callRatingWrapper}>
                                                <span className={classes.callRatingLabel}>Your Rating</span>
                                                <Rating
                                                    value={formData.numberOfStar}
                                                    onChange={(event, newValue) => {
                                                        handleChangeFormData(newValue, "numberOfStar");
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {
                                    formData.numberOfStar < 5 &&
                                    (
                                        <>
                                            <div className={classes.middleSection}>
                                                <div className={'lineML'}>Why did you rate your call quality less than 5 stars?</div>
                                                <div className={'lineML1'}>Our team will review the info you submit to improve our calling platform.</div>
                                                <div className={'lineML2'}>Please provide as much detail as possible.</div>
                                            </div>

                                            <div className={classes.bottomSection}>
                                                <div className={classes.bottomSectionLabel}>
                                                    <span>Comments</span> <Divider/>
                                                </div>

                                                <BasicInput
                                                    multiline
                                                    rows={10}
                                                    className={classes.callReviewNote}
                                                    value={formData.note}
                                                    onChange={(event) => {
                                                        handleChangeFormData(event.target.value, "note");
                                                    }}
                                                />

                                                <div className={classes.callSummary}>
                                                    <div className={'callTime'}>
                                                        <span className={'lbl'}>Time of Call: </span>
                                                        {renderCallTime()}
                                                    </div>
                                                    <div className={'callDetails'}>
                                                        <span className={'lbl'}>Call Details: </span>
                                                        {renderCallDetails()}
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )
                                }
                            </div>

                            <div className={classes.footer}>
                                <button
                                    onClick={handleSubmitDisposition}
                                    className={`${classes.button} ${classes.confirmButton}`}
                                    disabled={submitting || !formData.note || !formData.numberOfStar}
                                >
                                    Submit Feedback
                                </button>
                            </div>
                        </div>
                }
            </Fade>
        </Modal>
    );
};

export default CallReviewModal;